import type { ReactNode } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from 'app/javascript/components/ui/card';

interface HealthPanelProps {
  icon: ReactNode;
  title: string;
  // Right-aligned slot in the header — a count, a badge, a link.
  action?: ReactNode;
  className?: string;
  contentClassName?: string;
  children: ReactNode;
}

// One section of the health page. Tighter than the default Card padding: this
// screen is read, not filled in, so density beats breathing room.
export default function HealthPanel({
  icon,
  title,
  action,
  className,
  contentClassName = 'p-4',
  children,
}: HealthPanelProps) {
  return (
    <Card className={className}>
      <CardHeader className="flex-row items-center justify-between gap-3 space-y-0 border-b p-4">
        <CardTitle className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-muted-foreground">
          {icon}
          {title}
        </CardTitle>
        {action}
      </CardHeader>
      <CardContent className={contentClassName}>{children}</CardContent>
    </Card>
  );
}
